var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4991C24.8365 32.4991 32 25.3356 32 16.4991C32 7.66249 24.8365 0.499023 16 0.499023C7.16344 0.499023 0 7.66249 0 16.4991C0 25.3356 7.16344 32.4991 16 32.4991Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_3465)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31485 25.4577C7.86732 25.4577 7.43812 25.2799 7.12167 24.9635C6.80522 24.647 6.62744 24.2178 6.62744 23.7703V12.7274H31.8104V23.7703C31.8104 24.2178 31.6326 24.647 31.3162 24.9635C30.9997 25.2799 30.5705 25.4577 30.123 25.4577H8.31485ZM14.8153 19.0883C14.8123 18.4294 14.5484 17.7985 14.0814 17.3336C13.6144 16.8687 12.9823 16.6077 12.3233 16.6077C11.9928 16.6067 11.6654 16.6717 11.3603 16.7988C11.0551 16.9259 10.7784 17.1126 10.5464 17.348C10.3143 17.5834 10.1316 17.8627 10.0088 18.1696C9.88601 18.4765 9.82569 18.8048 9.83138 19.1353C9.83761 19.7962 10.1061 20.4276 10.5779 20.8905C11.0496 21.3534 11.6859 21.61 12.3468 21.6037C13.0077 21.5975 13.6391 21.329 14.102 20.8573C14.5649 20.3855 14.8215 19.7492 14.8153 19.0883Z",
    fill: "#2948CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M30.123 7.35242H8.30061C7.85555 7.35617 7.43 7.53561 7.11663 7.85165C6.80325 8.1677 6.62743 8.59475 6.62744 9.03982V10.592H31.7748V9.03982C31.7749 8.5984 31.602 8.17451 31.2932 7.85906C30.9844 7.54361 30.5643 7.36173 30.123 7.35242Z",
    fill: "#2948CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_3465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6315,
    height: 19.2236,
    fill: "white",
    transform: "translate(6.36841 6.88757)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.924c4a92dd5f7dc457fa7844dfc6b5b9.svg";
export { ForwardRef as ReactComponent };